import useSWR from "swr";

const optionArgs = {};

export const useSpecies = (options = optionArgs) => {
  const { data, error } = useSWR(
    `${process.env.REACT_APP_BASE_URL_ROLES}/data-master/specie`,
    { ...options }
  );

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
};
